import { formatRegionLocation } from '../utils/regionLocation';
import React from 'react';
import { Alert, Box, TextField, Typography } from '@mui/material';

export const awsParentRegion = (code: string) =>
  code.match(/^([a-z]{2}(?:-[a-z]+)+-\d+)-[a-z0-9]+-\d+[a-z]$/)?.[1] || code;

export interface LocationLaunchConfig {
  key_pair_name?: string | null;
  subnet_id?: string | null;
  security_group_id?: string | null;
  instance_type?: string | null;
}

export default function AwsLocationSettings({ code, value, onChange }: {
  code: string;
  value?: LocationLaunchConfig | null;
  onChange: (value: LocationLaunchConfig) => void;
}) {
  const parent = awsParentRegion(code);
  const local = parent !== code;
  return <Box sx={{ display: 'grid', gap: 2 }}>
    <Typography variant="subtitle2">AWS launch settings{local ? ' · Local Zone' : ''}</Typography>
    {local && <Alert severity="info">
      Parent region: {formatRegionLocation(parent)}. Use an AMI from this region and a subnet in {code} with an internet gateway route.
      The zone must be opted in. Instance types vary by zone; launch validates availability and architecture.
    </Alert>}
    <TextField label="Subnet ID" value={value?.subnet_id || ''}
      helperText={local ? 'Select the Local Zone subnet. If blank, discovery requires exactly one public subnet in this zone.' : 'Optional override for this location.'}
      onChange={e => onChange({ ...value, subnet_id: e.target.value.trim() })} fullWidth />
    <TextField label="Security group ID" value={value?.security_group_id || ''}
      helperText="Must belong to the subnet’s VPC. Blank uses the provider’s security group."
      onChange={e => onChange({ ...value, security_group_id: e.target.value.trim() })} fullWidth />
    <TextField label="Instance type for this location" value={value?.instance_type || ''}
      helperText="For example, t3.medium if offered in this zone. Used when bot instance type is Auto."
      onChange={e => onChange({ ...value, instance_type: e.target.value.trim() })} fullWidth />
    <TextField label="Operator key pair" value={value?.key_pair_name || ''}
      helperText="Optional parent-region EC2 key pair override."
      onChange={e => onChange({ ...value, key_pair_name: e.target.value.trim() })} fullWidth />
  </Box>;
}
